<template>
  <div :class="{ 'mobile-nav-active': nav }">
    <!-- ======= Mobile nav toggle button ======= -->
    <button
      type="button"
      @click="toggleNav"
      class="mobile-nav-toggle d-xl-none"
    >
      <i
        :class="[
          nav ? 'icofont icofont-close' : 'icofont icofont-navigation-menu'
        ]"
      ></i>
    </button>

    <!-- ======= Header ======= -->
    <header id="header">
      <div class="d-flex flex-column">
        <div class="profile">
          <img
            src="../../assets/img/jotweb_logo.png"
            alt=""
            class="img-fluid rounded-circle"
          />
          <h1 class="text-light"><a href="/">Jotweb</a></h1>
          <div class="social-links mt-3 text-center">
            <a
              href="#"
              title="Twitter"
              class="twitter"
              ><i class="bx bxl-twitter"></i
            ></a>
            <a
              href="#"
              title="Facebook"
              class="facebook"
              ><i class="bx bxl-facebook"></i
            ></a>
            <a href="https://wa.link/bbo97o" title="Whatsapp" class="whatsapp"
              ><i class="bx bxl-whatsapp"></i
            ></a>
            <a href="https://github.com/Joenif" title="Github" class="github"
              ><i class="bx bxl-github"></i
            ></a>
            <a
              href="#"
              title="Linkedin"
              class="linkedin"
              ><i class="bx bxl-linkedin"></i
            ></a>
          </div>
        </div>

        <nav class="nav-menu">
          <ul>
            <li>
              <router-link to="/"><i class="bx bx-home"></i> Home</router-link>
            </li>
            <li>
              <router-link to="/about"
                ><i class="bx bx-user"></i> About Us
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/resume"
                ><i class="bx bx-file-blank"></i> Resume</router-link
              >
            </li> -->
            <li>
              <router-link to="/portfolio"
                ><i class="bx bx-book-content"></i> Portfolio</router-link
              >
            </li>
            <li>
              <router-link to="/services"
                ><i class="bx bx-server"></i> Services</router-link
              >
            </li>
            <li>
              <router-link to="/contact"
                ><i class="bx bx-envelope"></i> Contact</router-link
              >
            </li>
          </ul>
          <!-- <ul>
          <li class="active"><a href="index.html"><i class="bx bx-home"></i> <span>Home</span></a></li>
          <li><a href="#about"><i class="bx bx-user"></i> <span>About</span></a></li>
          <li><a href="#resume"><i class="bx bx-file-blank"></i> <span>Resume</span></a></li>
          <li><a href="#portfolio"><i class="bx bx-book-content"></i> Portfolio</a></li>
          <li><a href="#services"><i class="bx bx-server"></i> Services</a></li>
          <li><a href="#contact"><i class="bx bx-envelope"></i> Contact</a></li>

        </ul> -->
        </nav>
        <!-- .nav-menu -->
        <!-- <button type="button" class="mobile-nav-toggle d-xl-none"><i class="icofont icofont-navigation-menu"></i></button> -->
      </div>
    </header>
    <!-- End Header -->
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      nav: false
    };
  },
  methods: {
    toggleNav() {
      this.nav = !this.nav;
    }
  }
};
</script>

<style scoped>
nav {
  a {
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.mobile-nav-toggle i {
    color: #bebebe!important;
}
</style>
